// calculating discounts used by upsell app in cart
(function() {
	$(document).ready(function () {
		if($('body.template-cart').length > 0) {

			var candyrackDiscount = window.localStorage.getItem('candyrack-discounted-product');
			if(null === candyrackDiscount) {
				return;
			}

			candyrackDiscount = JSON.parse(candyrackDiscount);

			// this is the base product which triggers an upsell
			var $baseProduct = $('tr[data-product-id=' + candyrackDiscount.relatedProductId + ']');
			// this is the extra product added by the upsell
			var $extraProduct = $('tr[data-variant-id=' + candyrackDiscount.variantId + ']');
			// this is the grand total price
			var $priceGrandTotal = $('.grid__item > p .cart__subtotal .money');
			// this is the discounted grand total price
			var $priceGrandTotalDiscounted = $('.cart--order-discount-wrapper');
			//var $discountedGrandTotal = $('.cart--order-discount-wrapper');
			// this is the price info of the extra product
			var $priceInfoOfExtraProduct = $extraProduct.find('.price-info');
			// this is the total price of the extra product
			var $priceTotalOfExtraProduct = $extraProduct.find('.cart-total-label');

			if($extraProduct.length === 0 || $baseProduct.length === 0) {
				return;
			}

			// qty of the product to discount (this is the one that will be added by the upsell app)
			var qtyOfExtraProduct = $extraProduct.find('.js-qty__num').val();
			// qty of the product which triggers the discount
			var qtyOfBaseProduct = $baseProduct.find('.js-qty__num').val();
			// you will get only n discounted extra products for n added base products
			// So if the user added some more of the discounted products, it will not discount all of them but only the number of base products
			var qtyToDiscount = Math.min(qtyOfExtraProduct, qtyOfBaseProduct);
			// price of the discounted product if not discounted
			var priceOriginalOfExtraProduct = ($extraProduct.find('.td-single-price').attr('data-price')/100).toFixed(2);
			// actually subtotal... total price before shipping. Contains all products in the cart
			var priceGrandTotalOriginal = $('[data-subtotal]').attr('data-subtotal')/100;
			// get the new discounted price from the app via localstorage
			var priceDiscountedOfExtraProduct = (Math.ceil(candyrackDiscount.discountedPrice*100)/100).toFixed(2);
			// calculate the new discounted price per product regarding quantities
			var priceTotalDiscounted = priceDiscountedOfExtraProduct * qtyToDiscount + priceOriginalOfExtraProduct * (qtyOfExtraProduct - qtyToDiscount);
			// calculate the amount that was saved in total
			var discountTotal = priceOriginalOfExtraProduct*qtyOfExtraProduct - priceTotalDiscounted;

			if(qtyToDiscount < qtyOfExtraProduct) {
				// only partial discount of the extra product
				// clone the price info and prepend the quantities
				var $priceInfoClone = $priceInfoOfExtraProduct.clone().insertBefore($priceInfoOfExtraProduct);
				$priceInfoOfExtraProduct.find('.single-price').html('<span>' + qtyToDiscount + ' x <del><span class="money">' + formatPrice(priceOriginalOfExtraProduct) + '</span></del></span><span class="h5 single-price"><span class="order-discount discount--sale-color"><span class="money">' + formatPrice(priceDiscountedOfExtraProduct) + '</span></span></span>')
				$priceInfoClone.find('.unit-price').remove();
				$priceInfoClone.find('.single-price .money').text((qtyOfExtraProduct - qtyToDiscount) + ' x ' + $priceInfoClone.find('.single-price .money').text());
			} else {
				// the extra product will be discounted for whole quantity
				$priceInfoOfExtraProduct.find('.single-price').html('<span><del><span class="money">' + formatPrice(priceOriginalOfExtraProduct) + '</span></del></span><span class="h5 single-price"><span class="order-discount discount--sale-color"><span class="money">' + formatPrice(priceDiscountedOfExtraProduct) + '</span></span></span>')
			}
			// update total price of extra product
			$priceTotalOfExtraProduct.html('<span class="h5 single-price"><del><span class="money">' + formatPrice(priceOriginalOfExtraProduct*qtyOfExtraProduct) + '</span></del></span><span class="h5 single-price"><span class="order-discount discount--sale-color"><span class="money">' + formatPrice(priceTotalDiscounted) + '</span></span></span>')
			
			//$discountedGrandTotal.html('<span class="h3 cart__subtotal"><span class="money">' + formatPrice(priceGrandTotalOriginal - discountTotal) + '</span></span>');
			// update the grand total
			$priceGrandTotalDiscounted.html('<span class="h3 cart__subtotal"><span class="money">' + formatPrice(priceGrandTotalOriginal - discountTotal) + '</span></span>');
			$priceGrandTotal.wrap('<del></del>');
		}
	});

	function formatPrice (price, currency) 
	{
		currency = currency ? currency : '€';
		return currency + parseFloat(price).toFixed(2).replace('.', ',');
	}

}());


//dropdown-menu

function toggleDropdown() {
  document.getElementById("blog-dropdown-list").classList.toggle("show");
};

window.onclick = function(event) {
  if (!event.target.matches("#blog-dropdown") && !event.target.matches(".header--supporting-text") && !event.target.matches(".icon-dropdown")) {
    document.getElementById("blog-dropdown-list") && document.getElementById("blog-dropdown-list").classList.remove('show');
  }
}

//paywhirl

$(document).ready(function () {
	if($('.product-details-wrapper').length > 0) {
		$('input[name="paywhirl-plan-selector-group"]').trigger( "click" );
		$('.paywhirl-plan-selector-group label').css("display", "none")
	}
});